export default {"src":"/_next/static/media/become-seller-bg.e085e283.svg","height":389,"width":354,"blurWidth":0,"blurHeight":0};